import { test } from 'last-validator'

export const isURL = test((value) => {
    try {
        new URL(value)
    } catch (e) {
        console.error('Error validating URL', e)
        return false
    }
    return true
}, 'Nesprávne zadaná URL adresa, prosím zadajte ako http://www.priklad.sk')
